const assetPrefix = process.env.NEXT_PUBLIC_ASSET_PREFIX || "";
const deploymentId = process.env.NEXT_PUBLIC_VERCEL_DEPLOYMENT_ID || "";

const LEGACY_STATIC_HOST = "static.edgen.tech";
const EDWEALTH_STATIC_HOST = "static.edwealth.ai";

/** V2.7.2：将遗留 CDN 域名迁移至 Edwealth 静态资源域 */
const replaceLegacyStaticHost = (url: string): string =>
  url.includes(LEGACY_STATIC_HOST)
    ? url.replaceAll(LEGACY_STATIC_HOST, EDWEALTH_STATIC_HOST)
    : url;

/**
 * 获取资源 URL
 * @param asset 资源路径
 * @returns 资源 URL
 */
export const getAssetsUrl = (asset: string) => {
  // 1. 如果 asset 无效，直接返回
  if (!asset) {
    return asset;
  }

  // 2. 如果是绝对 URL、协议相对 URL 或 Data URI，替换遗留域名后返回
  if (/^(https|http|data|blob):/.test(asset) || asset.startsWith("//")) {
    return replaceLegacyStaticHost(asset);
  }

  // 3. 如果没有部署信息，返回原始 asset (适用于本地开发)
  if (!assetPrefix || !deploymentId) {
    return asset;
  }
  const [, id] = deploymentId.split("_");
  if (!id) {
    return asset;
  }

  // 4. 安全拼接路径
  const cleanedAssetPrefix = assetPrefix.endsWith("/")
    ? assetPrefix.slice(0, -1)
    : assetPrefix;
  const cleanedAsset = asset.startsWith("/") ? asset.slice(1) : asset;

  return [cleanedAssetPrefix, cleanedAsset].join("/");
};
